import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomDateParserFormatter extends NgbDateParserFormatter {
    // From string (yyyymmdd) to parsed result
    parse(value: string): NgbDateStruct | null {
        if (!value) {
            return null;
        }

        const yearStr = value.substring(0, 4);
        const monthStr = value.substring(4, 6);
        const dayStr = value.substring(6, 8);

        const year = Number(yearStr);
        const month = Number(monthStr);
        const day = Number(dayStr);

        if (isNaN(year) || isNaN(month) || isNaN(day) ||
        month < 1 || month > 12 || day < 1 || day > 31) {
            return null;
        }

        return { year, month, day };
    }

    // From NgbDateStruct to formatted string
    format(date: NgbDateStruct | null): string {
        if (!date) {
            return '';
        }

        // Zero-pad month and day
        const month = date.month.toString().padStart(2, '0');
        const day = date.day.toString().padStart(2, '0');

        return `${date.year}${month}${day}`;
    }
}
